import type { ReasonReportListing, ReportListingRequest, EmailVehicleRequest } from './listing.type';

export const reportListing = (data: ReportListingRequest) => apiClient().post('/listing/report-listing', data);

export const getReasonReportListing = async () => {
  const res = await apiClient().get<{ reason: ReasonReportListing[] }>('/listing/get-reason-report-listing');

  return res.data.reason;
};

export const sendListingToFriend = (data: EmailVehicleRequest) =>
  apiClient().post('/listing/send-listing-to-friend', data);
